module.exports = __webpack_public_path__ + "static/media/mainimg-06.78cd605f.png";